export const environment = {
  production: false,
  gatewayUrl: 'https://reservedine.com/api',
  authServerUrl: 'https://auth.reservedine.com'
};
